import { forwardRef, type Ref, type SVGProps } from "react";
const IconTaxFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M26 2H6C3.5 2 2 3.87 2 7v21a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7c0-2.8 1.68-3 2-3 .08 0 2 0 2 3a3.44 3.44 0 0 1-2.32 3.05 1 1 0 1 0 .64 1.9C26.47 11.9 30 10.68 30 7c0-4-2.62-5-4-5M7 6h6a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2m8 14a1 1 0 1 1-1-1 1 1 0 0 1 1 1m-6-8H7a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2m11 15a1 1 0 1 1 1-1 1 1 0 0 1-1 1m.71-6.29-6 6a1 1 0 0 1-1.42 0 1 1 0 0 1 0-1.42l6-6a1 1 0 0 1 1.42 1.42"
    />
  </svg>
);
const ForwardRef = forwardRef(IconTaxFilledSVG);
ForwardRef.displayName = "IconTaxFilled";
export { ForwardRef as IconTaxFilled };
